import { render, staticRenderFns } from "./comision.vue?vue&type=template&id=6911eeb6&"
import script from "./comision.vue?vue&type=script&lang=js&"
export * from "./comision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports